import React, { useEffect, useRef, useCallback } from 'react'
import TabMenu from '../components/TabMenu'
import { useLocation, useNavigate } from 'react-router-dom';
import { ref, onValue, push, update } from 'firebase/database';
import { db } from '../../';
import Map from '../game/map/Map';
import Loading from '../components/Loading';
import { Link } from 'react-router-dom';
import History from '../game/History';
import { getFunctions, httpsCallable } from 'firebase/functions';
import InfoModal from '../components/InfoModal';
import NetabareModal from './NetabareModal';
import ConfirmModal from '../components/ConfirmModal';

// ゲームステータスの表示文言（コンポーネント外の定数のため依存配列に含める必要がない）
const statusText = ['開始前', '自動', '逃走準備中', 'ゲーム進行中', '中断', '終了'];

const Control = ({userData}) => {
    // 捕まえたときに獲得 & 捕まった時に減少するスコア
    const catchScore = 100;

    const navigate = useNavigate();
    const [activeTab, setActiveTab] = React.useState(0);
    const [activeMissionTab, setActiveMissionTab] = React.useState(0);
    const location = useLocation();
    const functions = getFunctions();
    const activateFunc = httpsCallable(functions, 'activateGame');
    const inactivateFunc = httpsCallable(functions, 'inactivateGame');
    const finalizeRanking = httpsCallable(functions, 'finalizeRanking');
    const closeMission = httpsCallable(functions, 'finalizeMissionManual');
    const [loading, setLoading] = React.useState(false);
    const [loadingText, setLoadingText] = React.useState('');
    const [activateSuccessOpen, setActivateSuccessOpen] = React.useState(false);
    // 確認ダイアログ（window.confirmの代わり）。{ title, message, confirmLabel, cancelLabel, onConfirm } を渡して開く。
    const [confirmModal, setConfirmModal] = React.useState(null);
    const [gamePaused, setGamePaused] = React.useState(false);
    const [updatingTeam, setUpdatingTeam] = React.useState(false);
    const [updatingStatus, setUpdatingStatus] = React.useState(false);
    const [issuingMission, setIssuingMission] = React.useState(false);
    const [closingMission, setClosingMission] = React.useState(false);

    const {gameId} = location.state;
    const [gameData, setGameData] = React.useState({
        info: {
            auto: null,
            startTime: null,
            endTime: null
        }
    });
    const roles = ["逃走", "鬼"];
    const [focusMission, setFocusMission] = React.useState(null);
    const [focusTeam, setFocusTeam] = React.useState(null);
    const [status, setStatus] = React.useState(null);
    const [teamRole, setTeamRole] = React.useState(0);
    const [teamScore, setTeamScore] = React.useState(0);
    const [teamRetired, setTeamRetired] = React.useState(false);
    const [gameLog, setGameLog] = React.useState([]);
    const [newGameStatus, setNewGameStatus] = React.useState(0);
    const [gameStatusTime, setGameStatusTime] = React.useState(null);
    const intervalRef = useRef(null);
    const [outofTime, setOutofTime] = React.useState(true);

    // 発令済みミッションの編集用
    const [newMissionName, setNewMissionName] = React.useState('');
    const [newMissionDetail, setNewMissionDetail] = React.useState('');
    const [newMissionScore, setNewMissionScore] = React.useState(0);
    const [newMissionDeadline, setNewMissionDeadline] = React.useState(0);
    const [newMissionPenalty, setNewMissionPenalty] = React.useState(0);
    const [newMissionOptions, setNewMissionOptions] = React.useState([]);

    // ネタばれモーダル
    const [isOpen, setIsOpen] = React.useState(false);
    const [isPackaged, setIsPackaged] = React.useState(false);

    // オーナーシップの簡易チェック（フロントエンドの防御的チェック。実際の制御はサーバー側で行う）
    useEffect(() => {
        if(!userData || userData.loading) return;
        if(!gameId) return;

        if(userData.createdGames) {
            const owns = Object.values(userData.createdGames || {}).includes(gameId);
            if(!owns) {
                navigate('/');
            }
        }
    }, [userData, gameId, navigate]);

    // 読み込み時に一度だけ実行
    useEffect(() => {
        if(!gameId) return;

        // ゲームデータ取得
        const gameRef = ref(db, 'games/' + gameId);
        const unsubscribeGame = onValue(gameRef, (snapshot) => {
            const data = snapshot.val();
            setGameData(data);

            // アクティベートコストの計算
            calculateActivateCost(data);

            // 設定時間内であることを確認
            const date = new Date();
            const startTime = new Date(data.info.startTime);
            const endTime = new Date(data.info.endTime);

            if(date <= endTime && date >= startTime) {setOutofTime(false);}

            // ゲームパックの有無
            if(data.info.package) {
                setIsPackaged(true);
            } else {
                setIsPackaged(false);
            }
        });

        // ゲームアクティベート状態取得
        const activatedGameRef = ref(db, 'activatedGames/' + gameId);
        const unsubscribeActivatedGame = onValue(activatedGameRef, (snapshot) => {
            if(snapshot.exists()) {
                setGameData((prev) => ({
                    ...prev,
                    info: {
                        ...prev.info,
                        activated: snapshot.val().activated
                    }
                }));
            }
        });

        // ゲームログの取得
        const gameLogRef = ref(db, 'gameLogs/' + gameId);
        const unsubscribeGameLog = onValue(gameLogRef, (snapshot) => {
            if(snapshot.exists()) {
                setGameLog(snapshot.val());
            }
        });

        // アンマウント時、またはgameId変更時にリスナーを解除
        return () => {
            unsubscribeGame();
            unsubscribeActivatedGame();
            unsubscribeGameLog();
        };
    }, [gameId]);

    // gameLogのチーム情報をgameDataに反映
    useEffect(() => {
        if(intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }


        if(gameData.info && gameLog.teams) {
            setGameData((prev) => ({
                ...prev,
                teams: gameLog.teams
            }));
        }

        if(gameData.info && gameLog.status) {
            setNewGameStatus(gameLog.status.type);

            // ゲームステータスの時間計算
            if(gameLog.status.date) {
                intervalRef.current = setInterval(() => {
                    calcStatusTime(gameLog.status.date);
                }, 1000);
            }

            if(gameLog.status.type === 4) {
                setGamePaused(true);
            }
        }

        // アンマウント時にタイマーを解除
        return () => {
            if(intervalRef.current) {
                clearInterval(intervalRef.current);
                intervalRef.current = null;
            }
        };
        // gameData.infoはここでは「ゲームデータを読み込み済みか」の存在チェックとしてのみ参照しており、
        // 依存に含めるとcalculateActivateCost等によるinfo更新のたびに不要に再実行されてしまうため除外する。
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [gameLog])

    // ゲームステータスの時間計算
    const calcStatusTime = (date) => {
        const startDate = new Date(date);
        const now = new Date();
        const diff = now - startDate;
        const diffSec = Math.floor(diff / 1000);
        const hour = Math.floor(diffSec / 3600);
        const min = Math.floor((diffSec % 3600) / 60);
        const sec = diffSec % 60;

        setGameStatusTime(`${hour.toString().padStart(2, '0')}:${min.toString().padStart(2, '0')}:${sec.toString().padStart(2, '0')}`);
    }


    // ゲームアクティベート
    const activateGame = () => {
        //メンバーが1人もいない場合はアクティベート不可
        if(!gameData.members || gameData.members.length === 0) {alert("参加者がいません。"); return;}

        // 終了時刻を過ぎている自動ゲームはアクティベート不可
        const date = new Date();
        const endTime = new Date(gameData.info.endTime);
        if(gameData.info.auto && date > endTime) {
            alert("自動実行のゲームは、開始時刻を過ぎてからアクティベートできません。");
            return;
        }

        setConfirmModal({
            title: 'アクティベート',
            message: 'ゲームをアクティベートしますか？',
            onConfirm: () => executeActivateGame()
        });
    }

    const executeActivateGame = () => {
        console.log('Activate game');
        setLoadingText('アクティベート中…');
        setLoading(true);

        // Firebase Functionsを呼び出し
        activateFunc({gameId: gameId, username: userData.username})
        .then((response) => {
            console.log(response.data);
            if(response.data.message === "Game activated") {
                setActivateSuccessOpen(true);
            }

            if(response.data.message === "Not enough coin") {
                alert("クレジットが不足しています。");
            }

            setLoading(false);
        })
        .catch((error) => {
            console.error(error);
            alert("エラーが発生しました。");
            setLoading(false);
        });
    }

    // アクティベートコストの計算
    const calculateActivateCost = (gameDataTmp) => {
        //ゲーム時間の計算
        const startTime = new Date(gameDataTmp.info.startTime);
        const endTime = new Date(gameDataTmp.info.endTime);
        const diff = endTime - startTime;
        const diffHour = diff / 1000 / 60 / 60;
        const memberNum = gameDataTmp.members ? Object.keys(gameDataTmp.members).length : 0;

        //参加者数と乗算してコスト算出
        const cost = Math.ceil(diffHour * memberNum);
        
        setGameData((prev) => ({
            ...prev,
            info: {
                ...prev.info,
                cost: cost
            }
        }));
    }

    const getStatus = useCallback(() => {
        // ゲームステータスの取得
        let newStatus = "";

        if(!gameData.info.activated) {
            newStatus = "未アクティベート";
        } else {
            if(gameData.info.auto) {
                const date = new Date();
                const startDate = new Date(gameData.info.startTime);
                const endDate = new Date(gameData.info.endTime);
                const prepareLimitDate = new Date(gameData.info.prepareLimitTime);

                if(date < startDate) {
                    newStatus = "開始前";
                } else if(date >= startDate && date < prepareLimitDate) {
                    newStatus = "逃走準備中";
                } else if(date >= prepareLimitDate && date < endDate) {
                    newStatus = "ゲーム実行中";
                } else {
                    newStatus = "終了";
                }

                if(gamePaused) {
                    newStatus = "中断";
                }
            } else {
                if(gameLog.status) {
                    newStatus = statusText[gameLog.status.type];
                }
            }
        }

        setStatus(newStatus);
    }, [gameData, gamePaused, gameLog]);

    useEffect(() => {
        getStatus();
    }, [getStatus]);

    // アクティベート取り消し
    const resetGame = () => {
        setConfirmModal({
            title: 'アクティベート取消し',
            message: 'ゲームをリセットし、アクティベートを取り消してもよろしいですか？',
            onConfirm: () => {
                setConfirmModal({
                    title: 'アクティベート取消し（最終確認）',
                    message: 'ゲームのログデータ（履歴）がすべて削除されます。本当にアクティベートを取り消してよろしいですか？',
                    onConfirm: () => executeResetGame()
                });
            }
        });
    }

    const executeResetGame = () => {
        console.log("Reset game");
        setLoadingText('アクティベート取消し中…');
        setLoading(true);
        
        inactivateFunc({gameId: gameId})
        .then((response) => {
            console.log(response.data);
            if(response.data.message === "Game inactivated") {
                alert("アクティベートを取り消しました。");
            }
            setLoading(false);
        })
        .catch((error) => {
            console.error(error);
            alert("エラーが発生しました。");
            setLoading(false);
        });
    }


    // チームの編集
    // gameData.teamsをここで依存に含めると、他の操作によるライブ更新のたびに
    // 編集中のフォーム内容が上書きされてしまうため、focusTeamが変化した（＝ユーザーが編集対象を選び直した）時のみ発火させる。
    useEffect(() => {
        if(focusTeam !== null) {
            setTeamRole(gameData.teams[focusTeam].role);
            setTeamScore(gameData.teams[focusTeam].score);
            setTeamRetired(gameData.teams[focusTeam].retired);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [focusTeam]);

    // チームの更新
    const updateTeam = (index) => {
        // チームが選択されていない場合は更新不可
        // （未選択のままgameLogs/{gameId}/teams/nullに書き込まれてしまう不具合の再発防止）
        if(index === null) return;

        // アクティベートされていない場合は更新不可
        if(!gameData.info.activated) {alert("ゲームがアクティベートされていません。"); return;}

        if(updatingTeam) return;

        setConfirmModal({
            title: 'チーム情報の更新',
            message: 'チーム情報を更新しますか？',
            onConfirm: () => executeUpdateTeam()
        });
    }

    const executeUpdateTeam = () => {
        // チームが選択されていない場合は更新不可（updateTeam側のチェックに対する保険）
        if(focusTeam === null) return;

        setUpdatingTeam(true);

        // チーム情報の更新
        update(ref(db, 'gameLogs/' + gameId + '/teams/' + focusTeam), {
            score: Number(teamScore),
            role: Number(teamRole),
            retired: teamRetired === undefined ? false : teamRetired
        })
        .then(() => {
            // ログの追加
            return push(ref(db, 'gameLogs/' + gameId + '/history'), {
                time: new Date().toISOString(),
                action: 'チームデータ更新',
                actionNum: 1,
                teamId: focusTeam,
                team: {
                    name: gameData.teams[focusTeam].name,
                    role: Number(teamRole),
                    score: Number(teamScore),
                    color: gameData.teams[focusTeam].color,
                    retired: teamRetired === undefined ? false : teamRetired
                }
            });
        })
        .then(() => {
            setUpdatingTeam(false);
        })
        .catch((error) => {
            console.error(error);
            alert("チーム情報の更新に失敗しました。");
            setUpdatingTeam(false);
        });
    }

    // ゲームステータスの更新（DB更新＋履歴追加）
    const updateGameStatusData = () => {
        update(ref(db, 'gameLogs/' + gameId + '/status'), {
            type: Number(newGameStatus),
            date: new Date().toISOString()
        })
        .then(() => {
            // ログの追加
            return push(ref(db, 'gameLogs/' + gameId + '/history'), {
                time: new Date().toISOString(),
                action: 'ゲームステータスの更新',
                actionNum: 2,
                status: {
                    type: Number(newGameStatus),
                    typeText: statusText[Number(newGameStatus)],
                }
            });
        })
        .then(() => {
            setUpdatingStatus(false);
        })
        .catch((error) => {
            console.error(error);
            alert("ゲームステータスの更新に失敗しました。");
            setUpdatingStatus(false);
        });
    }

    // ゲームステータスの変更
    const changeGameStatus = () => {
        // アクティベートされていない場合は更新不可
        if(!gameData.info.activated) {alert("ゲームがアクティベートされていません。"); return;}

        if(updatingStatus) return;

        // 設定時間内であることを確認
        const date = new Date();
        const startTime = new Date(gameData.info.startTime);
        const endTime = new Date(gameData.info.endTime);

        if(date < startTime && Number(newGameStatus) !== 5) {alert("開始時刻になっていません。"); return;}
        if(date > endTime && Number(newGameStatus) !== 5) {alert("終了時刻を過ぎています。"); return;}

        // 終了済みの場合は更新不可
        if(gameLog.status.type === 5) {alert("ゲームは終了しています。"); return;}


        setConfirmModal({
            title: 'ステータス変更',
            message: 'ゲームステータスを変更しますか？',
            onConfirm: () => {
                // 終了に変更する場合は、ランキングを確定してからステータスを更新する
                if(Number(newGameStatus) === 5) {
                    setConfirmModal({
                        title: 'ランキングの確定',
                        message: 'ゲームを終了し、ランキングを確定します。終了後、ステータスは変更できません。',
                        onConfirm: () => {
                            setUpdatingStatus(true);
                            finalizeRanking({gameId: gameId})
                            .then(() => {
                                updateGameStatusData();
                            })
                            .catch((error) => {
                                console.error(error);
                                alert("ランキングの確定に失敗したため、ゲームを終了できませんでした。");
                                setUpdatingStatus(false);
                            });
                        }
                    });
                    return;
                }

                // ゲームステータスの更新
                setUpdatingStatus(true);
                updateGameStatusData();
            }
        });
    }

    // ミッションの発令
    const issueMission = (index) => {
        if(!gameData.info.activated) {alert("ゲームがアクティベートされていません。"); return;}

        //ゲーム時間外は更新不可
        if(outofTime) {alert("ゲーム時間外は更新できません。"); return;}

        if(issuingMission) return;

        setConfirmModal({
            title: 'ミッション発令',
            message: 'ミッションを発令しますか？',
            onConfirm: () => executeIssueMission(index)
        });
    }

    const executeIssueMission = (index) => {
        setIssuingMission(true);

        const date = new Date();
        const deadline = new Date(date.getTime() + gameData.missions[index].time.end * 60000);

        // ミッション情報の更新
        update(ref(db, 'games/' + gameId + '/missions/' + index), {
            issued: true
        })
        .then(() => {
            return push(ref(db, 'gameLogs/' + gameId + '/missions'), {
                ...gameData.missions[index],
                deadline: deadline.toISOString(),
                missionId: index,
                reports: [],
                startTime: date.toISOString()
            });
        })
        .then(() => {
            // ログの追加
            return push(ref(db, 'gameLogs/' + gameId + '/history'), {
                time: date.toISOString(),
                action: 'ミッション発令',
                actionNum: 3,
                mission: {
                    ...gameData.missions[index],
                    deadline: deadline.toISOString(),
                    missionId: index
                }
            });
        })
        .then(() => {
            alert('ミッションを発令しました');
            setIssuingMission(false);
        })
        .catch((error) => {
            console.error(error);
            alert("ミッションの発令に失敗しました。");
            setIssuingMission(false);
        });
    }

    // 発令済みミッションの情報を表示
    // gameLog.missionsをここで依存に含めると、他の操作によるライブ更新のたびに
    // 編集中のフォーム内容が上書きされてしまうため、focusMission/activeMissionTabが変化した時のみ発火させる。
    useEffect(() => {
        if(focusMission !== null && (activeMissionTab === 1 || activeMissionTab === 2)) {
            setNewMissionName(gameLog.missions[focusMission].name);
            setNewMissionDetail(gameLog.missions[focusMission].detail);
            setNewMissionScore(gameLog.missions[focusMission].score);
            setNewMissionPenalty(gameLog.missions[focusMission].penalty);
            setNewMissionOptions(gameLog.missions[focusMission].options);

            const deadline = new Date(gameLog.missions[focusMission].deadline);
            setNewMissionDeadline(deadline.getFullYear() + '-' + (deadline.getMonth() + 1).toString().padStart(2, '0') + '-' + deadline.getDate().toString().padStart(2, '0') + 'T' + deadline.getHours().toString().padStart(2, '0') + ':' + deadline.getMinutes().toString().padStart(2, '0'));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [focusMission, activeMissionTab]);

    // 発令済みミッションの更新
    const updateMission = () => {
        //ゲーム時間外は更新不可
        if(outofTime) {alert("ゲーム時間外は更新できません。"); return;}

        // 締め切り済みのミッションは更新不可
        if(gameLog.missions[focusMission]?.closed) {
            alert("締切済みのミッションは更新できません。");
            return;
        }

        setConfirmModal({
            title: 'ミッション内容の変更',
            message: 'ミッションの内容を変更してよろしいですか？',
            onConfirm: () => executeUpdateMission()
        });
    }

    const executeUpdateMission = () => {
        update(ref(db, 'gameLogs/' + gameId + '/missions/' + focusMission), {
            name: newMissionName,
            detail: newMissionDetail,
            deadline: new Date(newMissionDeadline).toISOString(),
            score: Number(newMissionScore),
            penalty: Number(newMissionPenalty),
            options: newMissionOptions
        })
        .then(() => {
            // ログに記録
            return push(ref(db, 'gameLogs/' + gameId + '/history'), {
                time: new Date().toISOString(),
                action: 'ミッション内容の変更',
                actionNum: 9,
                mission: {
                    name: newMissionName,
                    detail: newMissionDetail,
                    deadline: new Date(newMissionDeadline).toISOString(),
                    score: Number(newMissionScore),
                    penalty: Number(newMissionPenalty),
                    options: newMissionOptions
                }
            });
        }).then(() => {
            alert('ミッション内容を変更しました');
        }).catch((error) => {
            console.error(error);
            alert("ミッション内容の変更に失敗しました。");
        });
    }

    // ミッションの締切処理
    const handleCloseMission = (missionLogKey) => {
        // 終了時刻を過ぎていない場合
        const mission = gameLog.missions[missionLogKey];
        if(!mission) return;

        const deadline = new Date(mission.deadline);
        if(deadline > new Date()) {
            alert("終了時刻を過ぎていないため、締切処理できません。終了時刻を待つか、終了時刻の変更を行ってください。");
            return;
        }

        if(closingMission) return;

        setConfirmModal({
            title: 'ミッション締切処理',
            message: 'このミッションを締切処理しますか？未提出のチームに設定された減点が適用されます。',
            onConfirm: () => executeCloseMission(missionLogKey)
        });
    }

    const executeCloseMission = (missionLogKey) => {
        setClosingMission(true);

        closeMission({
            gameId: gameId,
            missionId: gameLog.missions[missionLogKey].missionId,
            missionKey: missionLogKey
        })
        .then(() => {
            alert('ミッションを締切処理しました');
            setClosingMission(false);
        })
        .catch((error) => {
            console.error(error);
            alert("ミッションの締切処理に失敗しました。");
            setClosingMission(false);
        });
    }

    // ゲームデータのダウンロード（gameDataとgameLog）
    const downloadGameData = () => {
        const element = document.createElement('a');
        const file = new Blob([JSON.stringify({gameData: gameData, gameLog: gameLog})], {type: 'text/plain'});
        element.href = URL.createObjectURL(file);
        element.download = gameId + '_gameLog.json';
        document.body.appendChild(element);
        element.click();
    }

    // ミッションタブに切り替えた時、ゲームパックのデータならばネタばれモーダルを表示
    useEffect(() => {
        if(activeTab === 2 && isPackaged) {
            setIsOpen(true);
        }
    }, [activeTab, isPackaged]);

    // ゲームの一時停止
    const handlePaused = (paused) => {
        if(paused) {
            // ゲームを一時停止する処理（GameLogsのstatus/typeを4にする）
            update(ref(db, 'gameLogs/' + gameId + '/status'), {
                date: new Date().toISOString(),
                type: 4,
                typeText: "中断"
            })
            .then(() => {
                setGamePaused(true); // ローカルステートも更新

                // ログにも追加
                return push(ref(db, 'gameLogs/' + gameId + '/history'), {
                    time: new Date().toISOString(),
                    action: 'ゲームの中断',
                    actionNum: 13
                });
            })
            .catch((error) => {
                console.error(error);
                alert("ゲームの中断に失敗しました。");
            });
        } else {
            // ゲームを再開する処理（GameLogsのstatus/typeを3にする）
            update(ref(db, 'gameLogs/' + gameId + '/status'), {
                date: new Date().toISOString(),
                type: 1,
                typeText: "自動"
            })
            .then(() => {
                setGamePaused(false); // ローカルステートも更新

                // ログにも追加
                return push(ref(db, 'gameLogs/' + gameId + '/history'), {
                    time: new Date().toISOString(),
                    action: 'ゲームの再開',
                    actionNum: 14
                });
            })
            .catch((error) => {
                console.error(error);
                alert("ゲームの再開に失敗しました。");
            });
        }
    };

    // ゲームログをCSV形式でダウンロードする
    const downloadGameDataCSV = () => {
        if (!gameLog.history || !gameData.teams) {
            alert('ログデータまたはチーム情報がありません');
            return;
        }

        // CSVヘッダー
        const csvHeader = '日時,チーム名,ログのカテゴリ,変動スコア\n';
        
        let csvContent = csvHeader;

        // ゲームログの履歴を時系列順にソート
        const sortedHistory = Object.values(gameLog.history).sort((a, b) => 
            new Date(a.time) - new Date(b.time)
        );

        sortedHistory.forEach(log => {
            const time = new Date(log.time).toLocaleString('ja-JP');
            
            switch (log.actionNum) {
                case 1: // チームデータ更新
                    if (log.team && log.teamId !== undefined) {
                        const teamName = log.team.name || '';
                        csvContent += `"${time}","${teamName}","チームデータ更新","0"\n`;
                    }
                    break;

                case 2: // ゲームステータス更新
                    csvContent += `"${time}","","ゲームステータス更新","0"\n`;
                    break;

                case 3: // ミッション発令
                    if (log.mission) {
                        csvContent += `"${time}","","ミッション発令（${log.mission.name}）","0"\n`;
                    }
                    break;

                case 4: // ミッション提出
                    if (log.missionId && (log.team || log.team === 0)) {
                        const teamName = log.team.name || '';
                        const score = log.addScore || 0;
                        csvContent += `"${time}","${teamName}","ミッション提出（${log.missionTitle}）","+${score}"\n`;
                    }
                    break;

                case 7: // つかまえた
                    if (log.teams && Array.isArray(log.teams)) {
                        log.teams.forEach(team => {
                            const teamName = team.name || '';
                            const category = team.role === 1 ? 'つかまえた' : 'つかまった';
                            const scoreText = team.role === 1 ? catchScore * -1 : catchScore;
                            csvContent += `"${time}","${teamName}","${category}","${scoreText}"\n`;
                        });
                    } else if (log.team) {
                        // 旧形式のログ対応
                        const teamName = log.team.name || '';
                        csvContent += `"${time}","${teamName}","つかまえた・つかまった","0"\n`;
                    }
                    break;

                case 12: // ミッション締切
                    if (log.missionId && log.teams && Array.isArray(log.teams)) {
                        log.teams.forEach(team => {
                            const teamName = team.name || '';
                            const penalty = team.penalty || 0;
                            const scoreText = penalty < 0 ? `${penalty}` : '0';
                            csvContent += `"${time}","${teamName}","ミッション締切（${log.missionTitle}）","${scoreText}"\n`;
                        });
                    }
                    break;

                case 5: // アイテム使用
                    if (log.item && log.team) {
                        const teamName = log.team.name || '';
                        const score = log.item.score || 0;
                        const scoreText = score !== 0 ? (score > 0 ? `+${score}` : `${score}`) : '0';
                        csvContent += `"${time}","${teamName}","アイテム使用（${log.item.name}）","${scoreText}"\n`;
                    }
                    break;

                case 11: // ゲーム終了・ランキング確定
                    csvContent += `"${time}","","ゲーム終了・ランキング確定","0"\n`;
                    break;

                case 9: // ミッション内容変更
                    if (log.mission) {
                        csvContent += `"${time}","","ミッション内容変更（${log.mission.name}）","0"\n`;
                    }
                    break;

                case 13: // ゲーム中断
                    csvContent += `"${time}","","ゲーム中断","0"\n`;
                    break;

                case 14: // ゲーム再開
                    csvContent += `"${time}","","ゲーム再開","0"\n`;
                    break;

                default:
                    // その他のアクション
                    csvContent += `"${time}","","その他のアクション","0"\n`;
                    break;
            }
        });

        // BOM付きUTF-8でエンコード
        const bom = new Uint8Array([0xEF, 0xBB, 0xBF]);
        const blob = new Blob([bom, csvContent], { type: 'text/csv;charset=utf-8;' });
        
        // ダウンロード
        const element = document.createElement('a');
        element.href = URL.createObjectURL(blob);
        element.download = `${gameData.info.name || 'ゲーム'}_ログ_${new Date().toISOString().slice(0, 10)}.csv`;
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    };

    return (
        <div className='my-4 px-4 max-w-7xl mx-auto'>
            <Loading show={!gameData.info.name || loading} text={loading ? loadingText : "ゲームデータの読込み中…"} />

            <ConfirmModal
                isOpen={activateSuccessOpen}
                mode="notice"
                title="アクティベート完了"
                message="ゲームをアクティベートしました。"
                onClose={() => {
                    setActivateSuccessOpen(false);
                    window.location.reload();
                }}
            />

            <ConfirmModal
                isOpen={confirmModal !== null}
                mode="confirm"
                title={confirmModal?.title}
                message={confirmModal?.message}
                confirmLabel={confirmModal?.confirmLabel}
                cancelLabel={confirmModal?.cancelLabel}
                onConfirm={() => {
                    const onConfirm = confirmModal?.onConfirm;
                    setConfirmModal(null);
                    onConfirm && onConfirm();
                }}
                onCancel={() => setConfirmModal(null)}
            />

            <h2 className='text-center text-2xl mb-6'>コントローラ</h2>

            <TabMenu options={['基本設定', 'チーム', 'ミッション', 'マップ', '履歴']} active={activeTab} setActive={(index) => {setActiveTab(index)}} />

            {/* 基本設定 */}
            {activeTab === 0 && (
                <div>
                    <div className='rounded-lg bg-white shadow-sm m-3 p-4 max-w-2xl mx-auto'>
                        <h3 className='text-2xl mb-2'>{gameData.info.name}</h3>
                        <p className='text-gray-700'><span className='text-gray-500 me-3'><i className='bi bi-clock mx-1'></i>時刻</span>{new Date(gameData.info.startTime).toLocaleString()} ～ {new Date(gameData.info.endTime).toLocaleTimeString()}</p>
                        
                        <div className='md:grid md:grid-cols-2'>
                            <p className='text-gray-700'><span className='text-gray-500 me-3'><i className='bi bi-people-fill mx-1'></i>チーム数</span>{gameData.teams ? gameData.teams.length : 0}</p>
                            <p className='text-gray-700'><span className='text-gray-500 me-3'><i className='bi bi-person-fill mx-1'></i>参加者数</span>{gameData.members ? Object.keys(gameData.members).length : 0}</p>
                        </div>

                        <div className='text-end mt-2'>
                            {/* ゲームデータのダウンロード */}
                            <button className='text-purple-600 hover:text-purple-800 p-2 rounded-md hover:bg-purple-50' onClick={() => {downloadGameData()}}><i className='bi bi-download me-1'></i>履歴を保存（JSON）</button>
                            <button className='text-purple-600 hover:text-purple-800 p-2 rounded-md hover:bg-purple-50' onClick={() => {downloadGameDataCSV()}}><i className='bi bi-download me-1'></i>履歴を保存（CSV）</button>
                        </div>
                    </div>

                    <div className='p-2 mx-auto lg:grid lg:grid-cols-2'>
                        <div className='mb-3'>
                            <h3 className='text-lg text-purple-800 mb-2'>アクティベート
                                <InfoModal>
                                    <p className='text-gray-700 p-2'>ゲームの実行には、「アクティベート」が必要です。<br />
                                    利用料金としてクレジットを消費し、アクティベートすることで、ゲームを実行できます。<br />
                                    クレジットが不足している場合は購入してください。<br />
                                    <span className='text-red-700'>アクティベート後の参加登録はできません。</span></p>
                                </InfoModal>
                            </h3>

                            <div className='lg:grid lg:grid-cols-5'>
                                <div className='rounded-lg bg-white shadow-sm m-3 p-4 lg:col-span-3'>
                                    <h5 className='mb-1'>消費クレジット</h5>
                                    <p className='text-center text-2xl font-bold mb-3'>{gameData.info.cost} pt</p>

                                    {gameData.info.activated ? (
                                        <div className='text-center p-2'>
                                            <button className='rounded-lg bg-lime-50 text-lime-600 border border-lime-500 text-lg p-2 w-full' disabled type="button" onClick={() => activateGame()}><i className='bi bi-check-lg mx-2'></i>アクティベート済み</button>
                                        </div>
                                    ) : (
                                        <div className='text-center p-2'>
                                            <button className='rounded-lg bg-lime-500 text-white text-lg hover:bg-lime-600 py-2 px-4 w-full mb-2' type="button" onClick={() => activateGame()}><i className='bi bi-check-lg mx-2'></i>アクティベート</button>
                                            <p className='text-sm text-gray-500'>完了の表示が出るまで数秒お待ちください</p>
                                        </div>
                                    )}
                                </div>

                                <div className='rounded-lg bg-white shadow-sm m-3 p-4 lg:col-span-2'>
                                    <h5 className='mb-1'>所有クレジット</h5>
                                    <p className='text-center text-xl  mb-1'>{userData.coin} pt</p>

                                    <div className='text-center w-full p-2'>
                                        <Link to="/account/addCoin" className='block rounded-lg bg-white text-purple-600 border border-purple-500 text-base hover:bg-purple-100 p-2 w-full' type="button" ><i className='bi bi-wallet mx-2'></i>クレジット追加</Link>
                                    </div>
                                </div>
                            </div>
                            
                            {
                                (gameData.info && gameData.info.activated) && (
                                    <div className='text-center'>
                                        <button className='text-red-600/50 m-3 hover:text-red-600/80 p-2 rounded-md hover:bg-white/40' onClick={() => resetGame()}>アクティベートの取り消し</button>
                                    </div>
                                )
                            }
                        </div>

                        {
                            gameData.info.auto ? (
                                <div>
                                    <h3 className='text-lg text-purple-800 mb-2'>オートタイマー</h3>
                                    <p className='text-gray-700 text-sm p-2'>このゲームは、設定した時刻通りに自動的に実行されます。<br />手動での操作をご希望の場合は、ゲーム編集画面より変更してください。</p>

                                    <div className='rounded-lg bg-white shadow-sm m-3 p-4 '>
                                        <div className='mb-4 text-center'>
                                            <div className='mb-1 text-lg text-gray-700'>ステータス</div>
                                            <div className='text-xl text-purple-700'>{status}</div>
                                        </div>

                                        <h4 className='mb-3 text-lg text-gray-700 text-center'><i className='bi bi-clock me-1'></i>スケジュール</h4>
                                        <div className='md:grid md:grid-cols-3'>
                                            
                                            <div className='mb-3'>
                                                <h5 className='mb-1 text-gray-500'>開始時刻</h5>
                                                <div className='text-lg'>{new Date(gameData.info.startTime).toLocaleString()}</div>
                                            </div>

                                            <div className='mb-3'>
                                                <h5 className='mb-1 text-gray-500'>逃走準備終了時刻</h5>
                                                <div className='text-lg'>{new Date(gameData.info.prepareLimitTime).toLocaleString()}</div>
                                            </div>

                                            <div className='mb-3'>
                                                <h5 className='mb-1 text-gray-500'>終了時刻</h5>
                                                <div className='text-lg'>{new Date(gameData.info.endTime).toLocaleString()}</div>
                                            </div>
                                        </div>

                                        {/* 中断するチェックボックス */}
                                        <div className='mb-4'>
                                            <label className='flex items-center'>
                                                <input type="checkbox" checked={gamePaused} className='mr-2' onChange={(e) => {
                                                    const checked = e.target.checked;
                                                    setConfirmModal({
                                                        title: 'ステータス変更',
                                                        message: 'ゲームのステータスを変更しますか？',
                                                        onConfirm: () => handlePaused(checked)
                                                    });
                                                }} />
                                                <span className='text-gray-700'>ゲームを中断する</span>
                                                <InfoModal>
                                                    <p className='text-gray-700 p-2'>
                                                        ゲームを中断すると、ミッションの提出や役の交代などが不可能になります。<br/>
                                                        ゲームの時間は延長されません。<br/>
                                                        休憩時間や、トラブル発生時などにご使用ください。
                                                    </p>
                                                </InfoModal>
                                            </label>
                                        </div>

                                    </div>

                                    
                                </div>
                            ) : (
                                <div>
                                    <h3 className='text-lg text-purple-800 mb-2'>ゲームステータス
                                        <InfoModal>
                                            <p className='text-gray-700 p-2'>このゲームは、手動でゲームステータスの変更を行います。<br />指定した時刻通りに自動的に変更するには、編集画面で設定してください。</p>
                                        </InfoModal>
                                    </h3>
                                    
                                    <div className='rounded-lg shadow-sm p-2 bg-white m-3 md:grid md:grid-cols-2'>
                                        <div className='m-2 text-center'>
                                            <h5 className='text-gray-600 mb-1'>現在</h5>
                                            <div className='text-purple-700 text-xl mb-2'>{status}</div>
                                            {gameStatusTime && (<div className='play-regular text-gray-700 text-lg mb-2'><i className='bi bi-clock'></i> {gameStatusTime}</div>)}
                                        </div>

                                        <div className='m-2'>
                                            {
                                                (outofTime && gameData.info.activated) && (
                                                    <div className='mb-3'>
                                                        <h4 className='text-red-700 text-lg'>ゲーム時間外です</h4>
                                                        <p className='text-sm text-gray-500'>「終了」以外への変更はできません</p>
                                                    </div>
                                                )
                                            }
                                            <label>ステータス変更</label>
                                            <select value={newGameStatus} onChange={(e) => setNewGameStatus(e.target.value)} className='border border-gray-200 p-2 rounded-md w-full focus:outline-purple-300 mb-2'>
                                                <option value={0}>開始前</option>
                                                <option value={2}>逃走チーム準備</option>
                                                <option value={3}>ゲーム進行中</option>
                                                <option value={4}>中断</option>
                                                <option value={5}>終了</option>
                                            </select>

                                            <button type="button" disabled={updatingStatus} onClick={() => changeGameStatus()} className='bg-purple-500 text-white p-2 px-4 rounded-lg hover:bg-purple-600 w-full my-3 disabled:opacity-50'><i className='bi bi-floppy me-2'></i>更新</button>
                                        </div>
                                        
                                    </div>
                                </div>
                            )
                        }
                    </div>
                </div>
            )}

            {/* チーム */}
            {activeTab === 1 && (
                <div className='p-2 mx-auto'>
                    <h3 className='text-lg text-purple-800 mb-2'>チーム管理 <span className='text-sm text-gray-600'>スコア順</span></h3>
                    
                    <div className='lg:grid lg:grid-cols-2'>
                        <div>
                            {
                                gameData.teams && gameData.teams.map((team, i) => ({...team, index: i})).sort((a, b) => b.score - a.score).map((team, index) => (
                                    <div className={'rounded-lg m-3 px-3 py-2 relative hover:bg-gray-50 cursor-pointer ' + ((focusTeam === team.index) ? 'border border-purple-500 shadow bg-purple-50' : 'bg-white shadow-sm')} key={team.index} onClick={() => setFocusTeam(team.index)}>
                                        <h4 className='text-lg text-purple-800 mb-2'><i className='bi bi-people-fill text-2xl me-2' style={{color: team.color}}></i>{team.name}</h4>
                                        <div className='ms-6 min-h-6'>
                                            {
                                                team.members && team.members.map((memberId, index2) => gameData.members[memberId] && (
                                                    <div className='inline-block rounded-md border py-1 px-2 m-1 text-gray-700' key={index + "_" + index2}>
                                                        <div className='text-sm'>{gameData.members[memberId]?.name}</div>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                        <div className='text-xl text-lime-700 font-semibold mb-2 absolute top-2 end-3'>
                                            <span className='text-base me-2 text-lime-700/70'>{(index + 1) + "位"}</span>
                                            {team.score} pt
                                        </div>
                                        <div className='text-xl text-purple-700 mb-2 absolute bottom-1 end-3'>
                                            {
                                                team.retired && (
                                                    <span className='text-lime-700 me-2 text-sm'>リタイア</span>
                                                )
                                            }
                                            {roles[team.role]}
                                        </div>
                                    </div>
                                ))
                            }
                        </div>

                        <div>
                            <div className='rounded-lg bg-white shadow-sm m-3 p-4'>
                                <h4 className='text-lg text-purple-800 mb-2'>チーム編集</h4>
                                <div className='mb-3'>
                                    <label className='block text-sm font-medium text-gray-700'>チーム名</label>
                                    <input type="text" name="teamName" disabled className='border border-gray-200 p-2 rounded-md w-full' value={(gameData.teams && focusTeam !== null) ? gameData.teams[focusTeam].name : ''} />
                                </div>

                                <div className='grid grid-cols-2 gap-3 mb-6'>
                                    <div>
                                        <label className='block text-sm font-medium text-gray-700'>役</label>
                                        <select className='border border-gray-200 p-2 rounded-md w-full' value={teamRole} onChange={(e) => setTeamRole(e.target.value)}>
                                            <option value={0}>逃走</option>
                                            <option value={1}>鬼</option>
                                        </select>
                                    </div>

                                    <div>
                                        <label className='block text-sm font-medium text-gray-700'>スコア</label>
                                        <input type="number" name="teamScore" className='border border-gray-200 p-2 rounded-md w-full' value={teamScore} onChange={(e) => setTeamScore(e.target.value)} />
                                    </div>

                                    <div className='ms-2'>
                                        <input type="checkbox" checked={teamRetired} onChange={(e) => setTeamRetired(e.target.checked)} name="teamActive" id="teamActive" className='border border-gray-200 rounded-md' />
                                        <label htmlFor="teamActive" className='text-gray-700 ms-2'>リタイア</label>
                                    </div>
                                </div>

                                <div className='mb-3 '>
                                    <button className='bg-purple-500 text-white p-2 px-4 rounded-lg hover:bg-purple-600 w-full disabled:opacity-50' disabled={updatingTeam || focusTeam === null} onClick={() => updateTeam(focusTeam)} ><i className='bi bi-floppy me-2'></i>更新</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* マップ */}
            {activeTab === 3 && (
                <div className='p-2 mx-auto'>
                    <Map gameId={gameId} />
                </div>
            )}

            {/* ミッション */}
            {activeTab === 2 && (
                <div className='p-2 mx-auto'>
                    <h3 className='text-lg text-purple-800 mb-2'>ミッション管理</h3>

                    <TabMenu options={['発令する', '受付中', '終了']} active={activeMissionTab} setActive={(index) => {setFocusMission(null);setActiveMissionTab(index)}} className="mx-6" />

                    {/* ミッション発令 */}
                    {activeMissionTab === 0 && (
                        <div className='lg:grid lg:grid-cols-2'>
                            <div className='max-h-96 overflow-y-auto bg-purple-300/30 rounded-lg'>
                                {
                                    gameData.missions && gameData.missions.map((mission, index) => (
                                        <div className={'rounded-lg m-3 px-3 py-2 relative hover:bg-gray-50 cursor-pointer ' + ((focusMission === index) ? 'border border-purple-500 shadow bg-purple-50' : 'bg-white shadow-sm')} key={index} onClick={() => setFocusMission(index)}>
                                            <h4 className='text-lg text-purple-800 mb-3 mt-1'>
                                                <i className='bi bi-clipboard-check text-xl me-2'></i>{mission.name}

                                                {/* 発令済み？ */}
                                                {
                                                    mission.issued && (
                                                        <span className='absolute top-2 end-3 text-sm text-gray-500'>
                                                            発令済み
                                                        </span>
                                                    )
                                                }
                                            </h4>
                                            <div className='ms-6 mb-2'>
                                                <div className='text-sm text-gray-700'>{mission.detail.slice(0, 20)}</div>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>

                            {focusMission !== null && (
                                <div className='rounded-lg bg-white shadow-sm m-3 p-4 relative'>
                                    <div className='text-left text-gray-600 mb-2'>ミッション詳細</div>
                                    <h4 className='text-lg text-purple-800 mb-2'><i className='bi bi-clipboard-check text-xl me-2'></i>{gameData.missions[focusMission].name}</h4>

                                    <div className='mb-3 ms-3'>
                                        <h5 className='text-purple-700 mb-1'>詳細</h5>
                                        <p className='ms-3 text-sm whitespace-pre-wrap'>{gameData.missions[focusMission].detail}</p>
                                    </div>

                                    <div className='grid grid-cols-2 ms-3'>
                                        <div className='mb-3'>
                                            <h5 className='text-purple-700 mb-1'>報酬スコア</h5>
                                            <p className='ms-3 text-lg'>{gameData.missions[focusMission].score}pt</p>
                                        </div>

                                        <div className='mb-3'>
                                            <h5 className='text-purple-700 mb-1'>未達成時の減点</h5>
                                            <p className='ms-3 text-lg'>{gameData.missions[focusMission].penalty}pt</p>
                                        </div>
                                    </div>

                                    <div className='grid grid-cols-2 ms-3'>
                                        <div className='mb-3'>
                                            <h5 className='text-purple-700 mb-2'>発令時刻</h5>
                                            <p className='ms-3 text-base'>{gameData.missions[focusMission].time.start ? new Date(gameData.missions[focusMission].time.start).toLocaleString() : "-------"}</p>
                                            {
                                                gameData.missions[focusMission].options[2] === true && (
                                                    <p className='ms-3 text-sm text-gray-500'>{gameData.missions[focusMission].repeatInterval} 分ごとに発令</p>
                                                )
                                            }
                                            
                                            {
                                                gameData.missions[focusMission].time.startNext && (
                                                    <p className='ms-3 text-sm text-gray-500'>次回 {new Date(gameData.missions[focusMission].time.startNext).toLocaleTimeString()}</p>
                                                )
                                            }
                                        </div>

                                        <div className='mb-3'>
                                            <h5 className='mb-1 text-gray-500'>制限時間</h5>
                                            <p className='ms-3 text-base'>{gameData.missions[focusMission].time.end} 分間</p>
                                        </div>
                                    </div>

                                    <div className='mx-3 mb-4'>
                                        <h5 className='text-purple-700 mb-1'>提出権限</h5>
                                        <div className='grid grid-cols-2'>
                                            <div className='mb-3'>
                                                <i className={'text-xl me-1 ' + (!gameData.missions[focusMission].options[0] ? 'bi-check-lg text-green-600' : 'bi-x-lg text-red-700')}></i><label className='text-gray-700'>🏃‍♂️‍➡️逃走チーム</label>
                                            </div>

                                            <div className='mb-3'>
                                                <i className={'text-xl me-1 ' + (!gameData.missions[focusMission].options[1] ? 'bi-check-lg text-green-600' : 'bi-x-lg text-red-700')}></i><label className='text-gray-700'>👹鬼チーム</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='absolute top-3 end-3'>
                                        <button className='shadow-sm bg-white text-purple-600 py-1 px-2 rounded-lg border border-purple-500 hover:bg-purple-100 disabled:opacity-50' disabled={issuingMission} onClick={() => issueMission(focusMission)}><i className='bi bi-flag me-2'></i>すぐに発令</button>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}

                    {/* 受付中 / 終了済み */}
                    {(activeMissionTab === 1 || activeMissionTab === 2) && (
                        <div className='lg:grid lg:grid-cols-2'>
                            <div className='max-h-96 overflow-y-auto bg-purple-300/30 rounded-lg'>
                                {
                                    gameLog.missions && Object.keys(gameLog.missions).sort((a, b) => new Date(gameLog.missions[b].deadline) - new Date(gameLog.missions[a].deadline)).map((key, index) => {
                                        // 受付中(or 終了済み)のミッションのみ表示
                                        if((new Date(gameLog.missions[key].deadline).getTime() > new Date().getTime() && activeMissionTab === 1) || (new Date(gameLog.missions[key].deadline).getTime() <= new Date().getTime() && activeMissionTab === 2)) return (
                                        <div className={'rounded-lg m-3 px-3 py-2 relative hover:bg-gray-50 cursor-pointer ' + ((focusMission === key) ? 'border border-purple-500 shadow bg-purple-50' : 'bg-white shadow-sm')} key={key} onClick={() => setFocusMission(key)}>
                                            <h4 className='text-lg text-purple-800 mb-1 mt-1'><i className='bi bi-clipboard-check text-xl me-2'></i>{gameLog.missions[key].name}</h4>
                                            <div className='ms-6 mb-2'>
                                                <div className='text-sm text-gray-700'>{new Date(gameLog.missions[key].deadline).toLocaleTimeString()} まで</div>
                                            </div>
                                        </div>
                                    )
                                    return null;
                                    })
                                }
                            </div>

                            {focusMission !== null && (
                                <div className='rounded-lg bg-white shadow-sm m-3 p-4 relative'>
                                    <div className='flex justify-between mb-2'>
                                        <div className='text-left text-gray-600'>ミッション詳細</div>

                                        {/* 締め切り処理 */}
                                        { gameLog.missions[focusMission]?.closed ? (
                                            <span className='text-sm text-gray-500'><i className='bi bi-check-lg me-1 text-green-600 text-base'/>締切済み</span>
                                        ): (
                                            <button className='bg-red-50 border border-red-300 text-red-600 hover:bg-red-100 text-sm rounded-md px-2 py-1 disabled:opacity-50' disabled={closingMission} onClick={() => handleCloseMission(focusMission)}>締切処理</button>
                                        )}
                                    </div>

                                    <h4 className='text-lg text-purple-800 mb-2 flex'><i className='bi bi-clipboard-check text-xl me-2 mt-1'></i>
                                        <input value={newMissionName} onChange={(e) => setNewMissionName(e.target.value)} className='py-1 px-2 rounded-md border w-full focus:outline-purple-300' />
                                    </h4>
                                    <div className='mb-3 ms-3'>
                                        <h5 className='text-purple-700 mb-1'>詳細</h5>
                                        <textarea type="text" value={newMissionDetail} onChange={(e) => setNewMissionDetail(e.target.value)} className="w-full border p-2 rounded-md focus:outline-purple-300 whitespace-pre-wrap" />
                                    </div>
                                    <div className='grid grid-cols-2 ms-3'>
                                        <div className='mb-3'>
                                            <h5 className='text-purple-700 mb-1'>報酬スコア [pt]</h5>
                                            <input type="number" value={newMissionScore} onChange={(e) => setNewMissionScore(e.target.value)} className="w-32 border p-2 rounded-md focus:outline-purple-300" />
                                        </div>

                                        <div className='mb-3'>
                                            <h5 className='text-purple-700 mb-1'>未達成時の減点 [pt]</h5>
                                            <input type="number" value={newMissionPenalty} onChange={(e) => setNewMissionPenalty(e.target.value)} className="w-32 border p-2 rounded-md focus:outline-purple-300" />
                                        </div>
                                    </div>
                                    <div className='grid grid-cols-2 ms-3'>
                                        <div className='mb-3'>
                                            <h5 className='text-purple-700 mb-2'>発令時刻</h5>
                                            <p className='ms-3 text-base'>{new Date(gameLog.missions[focusMission].startTime).toLocaleString()}</p>
                                        </div>

                                        <div className='mb-3'>
                                            <h5 className='text-purple-700 mb-1'>締切時刻</h5>
                                            <input type="datetime-local" value={newMissionDeadline} onChange={(e) => setNewMissionDeadline(e.target.value)} className="w-full border p-2 rounded-md focus:outline-purple-300" />
                                        </div>
                                    </div>

                                    <div className='mb-3 ms-3'>
                                        <h5 className='text-purple-700 mb-1'>提出権限</h5>
                                        <div className='grid grid-cols-2'>
                                            <div className='mb-3'>
                                                <input type="checkbox" id="check_1" checked={!newMissionOptions[0]} onChange={(e) => setNewMissionOptions(prev => [!e.target.checked, prev[1], prev[2]])} />
                                                <label className='text-gray-700 ms-2' htmlFor='check_1'>逃走チーム</label>
                                            </div>

                                            <div className='mb-3'>
                                                <input type="checkbox" id="check_2" checked={!newMissionOptions[1]} onChange={(e) => setNewMissionOptions(prev => [prev[0], !e.target.checked, prev[2]])} />
                                                <label className='text-gray-700 ms-2' htmlFor='check_2'>鬼チーム</label>
                                            </div>
                                        </div>
                                    </div>


                                    <div className='mx-3 mb-4'>
                                        <button className='bg-purple-500 text-base w-full rounded-lg text-white p-2 px-4 hover:bg-purple-600' onClick={() => updateMission()}><i className='bi bi-flag me-2'></i>更新</button>
                                    </div>

                                    <div className='mb-3 ms-3'>
                                        <h5 className='text-purple-700 mb-2'>提出状況 <span className='text-gray-600 mx-2'>{gameLog.missions[focusMission].reports ? Object.keys(gameLog.missions[focusMission].reports).length : "0"} / {gameData.teams ? gameData.teams.length : "--"}</span></h5>
                                        
                                        <div className='md:grid md:grid-cols-2'>
                                            {
                                                gameLog.missions[focusMission].reports && Object.keys(gameLog.missions[focusMission].reports).map((id, index) => (
                                                    <div className='border border-gray-200 py-2 px-3 rounded-md relative m-1 cursor-pointer hover:bg-gray-50' key={index}>
                                                        <div className='text-base text-gray-700'><i className='bi bi-people-fill me-2' style={{color: gameData.teams[id].color}}></i>{gameData.teams[id].name}</div>
                                                        <div className='absolute top-2 end-3 text-gray-500'>{gameLog.missions[focusMission].reports[id].time ? new Date(gameLog.missions[focusMission].reports[id].time).toLocaleTimeString() : ""}</div>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                    
                </div>
            )}

            {/* 履歴 */}
            {activeTab === 4 && (
                <div className='p-2 mx-auto'>

                    <History gameId={gameId} likes={userData.likes} uid={userData.uid} />
                </div>
            )}

            {/* ネタばれモーダル */}
            <NetabareModal
                isOpen={isOpen}
                onClose={() => {setIsOpen(false)}}
                onLeave={() => {setIsOpen(false); setActiveTab(0)}}
            />
        </div>
    )
}

export default Control